<template>
  <div class="center-content">
    <div class="center-box">
      <div class="center-item" v-for="item in list" :key="item.title">
        <div class="title">{{item.title}}</div>
        <div class="num">{{item.num}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    postAction
  } from '@/api/manage'
  export default{
    data(){
      return{
        url: {
          queryHomeIndexDisposeNum: "/jeecg-engineering/ticket/tickets/queryHomeIndexDisposeNum",
        },
        list: [
          {title:this.$t('本月总用水量(万吨)'),num:858},
          {title:this.$t('抄表率(%)'),num:'97.56%'},
        ]
      }
    },
    methods:{
      init(){
        // this.getData();
      },
      getData(){
        postAction(this.url.queryHomeIndexDisposeNum,{}).then(res=>{
          if(res.success){
            var data = res.result;
            this.list[0].num = data.ticketsNum;
            this.list[1].num = data.finishTicketsNum;
            this.list[2].num = data.unFinishTicketsNum;
            this.list[3].num = data.timeOutTicketsNum;
            this.list[4].num = (data.ticketsFinishRatio*100).toFixed(2)+'%';
          }
        })
      }
    }
  }
</script>

<style scoped lang="less">
  .center-content{
    height: 100%;
    padding: 10px;
    .center-box{
      display: flex;
      justify-content: space-evenly;
      .center-item{
        width: 40%;
        text-align: center;
        .title{
          font-size: 20px;
          color: aqua;
        }
        .num{
          font-family: 'ds-digital-bold';
          color: #fff;
          font-size: 60px;
        }
      }
    }
  }
</style>